import { useContext } from 'react';
import { SiteContext } from '../../context/SiteContext';
import { CountryIsoCodes } from './Constants';

export const formatNumber = (
  val: number | undefined,
  dp: number,
  culture: string
): string => {
  const value = val === undefined ? 0 : val;
  const formattedValue = new Intl.NumberFormat(culture, {
    minimumFractionDigits: dp,
    maximumFractionDigits: dp
  }).format(value);
  return formattedValue;
};

export const getDateFormatString = (culture: string): string => {
  const formatObj = new Intl.DateTimeFormat(culture).formatToParts(new Date());
  return formatObj
    .map((obj) => {
      switch (obj.type) {
        case 'day':
          return 'dd';
        case 'month':
          return 'MM';
        case 'year':
          return 'yyyy';
        case 'literal':
          return obj.value;
        default:
          return obj.value;
      }
    })
    .join('');
};

export const getPlaceHolderFormatString = (culture: string): string => {
  const formatObj = new Intl.DateTimeFormat(culture).formatToParts(new Date());
  return formatObj
    .map((obj) => {
      switch (obj.type) {
        case 'day':
          return 'DD';
        case 'month':
          return 'MM';
        case 'year':
          return 'YYYY';
        case 'literal':
          return obj.value;
        default:
          return obj.value;
      }
    })
    .join('');
};

export const getDayMonthOrder = (culture: string): boolean => {
  const formatObj = new Intl.DateTimeFormat(culture).formatToParts(new Date());

  const delimiter = formatObj?.find((f) => f.type === 'literal')?.value ?? '/';

  return formatObj
    .map((obj) => {
      switch (obj.type) {
        case 'day':
          return 'DD';
        case 'month':
          return 'MM';
        case 'year':
          return 'YYYY';
        case 'literal':
          return obj.value;
        default:
          return obj.value;
      }
    })
    .join('')
    .split(delimiter)[0] === 'DD'
    ? true
    : false;
};

export const getCurrencySymbol = (): string => {
  const { site } = useContext(SiteContext);
  const countryCode = site.countryCode;
  switch (countryCode) {
    case CountryIsoCodes.DE:
    case CountryIsoCodes.AT:
    case CountryIsoCodes.ES:
      return '€';
    case CountryIsoCodes.GB:
      return '£';
    default:
      return '£';
  }
};

export const getDateByBrowserLanguage = (
  culture: string,
  inputDate: string
): string => {
  if (inputDate === '' || inputDate === null || inputDate === undefined) {
    return '';
  } else {
    const isDayFirst = getDayMonthOrder(culture);

    const formatObj = new Intl.DateTimeFormat(culture).formatToParts(
      new Date()
    );
    const delimiter =
      formatObj?.find((f) => f.type === 'literal')?.value ?? '/';

    const [day, month, year] = inputDate.split('/');
    if (isDayFirst) {
      return `${day}${delimiter}${month}${delimiter}${year}`;
    } else {
      return `${month}${delimiter}${day}${delimiter}${year}`;
    }
  }
};
